class CartDrawerSnippet {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.init();
  }
  popUpEvents=()=>{
    const parent = this.parent;
    const cartIcon = document.querySelector(".header-cart-btn");
    const closeIcon = parent.querySelector(".close-popup");  
    const overlay = document.querySelector(".common-overlay");
    let openFunction;
    if(window.innerWidth < 850){
      closeIcon && closeIcon.addEventListener("click",()=>{
        parent && parent.classList.remove("active");
        document.body.classList.remove("show-overlay");
      })
      cartIcon && cartIcon.addEventListener("click",()=>{
        parent.classList.add("active");
        document.body.classList.add("show-overlay");
      })
      overlay && overlay.addEventListener("click",()=> {
        parent && parent.classList.remove("active");
        document.body.classList.remove("show-overlay");
      })
      openFunction=()=>{
        cartIcon && cartIcon.click();
      }
    }else{
      document.addEventListener("mouseover",(e)=>{
        if((e.target.closest(".header-cart-btn") || e.target.closest(".cart-drawer")) && document.querySelector(".header-cart.filled")){
          parent && parent.classList.add("active");
        }else{
          parent && parent.classList.remove("active");
        }
      })
      openFunction=()=>{
        parent && parent.classList.add("active");
      }
    }

    window.updatePopup = async (open = false) =>{
      const res = await fetch("/?section=cart-drawer");
      const data = await res.text();
      const parser = new DOMParser();
      const updatedDom = parser.parseFromString(data,"text/html");
      const updatedCount = updatedDom.querySelector(".header-cart-btn");
      document.querySelector(".header-cart-btn").innerHTML = updatedCount.innerHTML;

      const updatedCart = updatedDom.querySelector(".ctdrawer");
      parent.innerHTML = updatedCart.innerHTML;
      this.clickEvents();
      this.popUpEvents();
      if(open && openFunction){
        openFunction();
      }
    }
  }
  updateCart = async (noCode = false) => {
    const cart = await fetch('/?section_id=cart-drawer');
    const response = await cart.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(response, 'text/html');
    console.log({doc});
    let oldCouponCode = document.querySelector(".cart-coupon-wrapper");
    let newCouponCode = doc.querySelector(".cart-coupon-wrapper");
    console.log({oldCouponCode,newCouponCode});
    if(oldCouponCode && newCouponCode && !noCode){
      oldCouponCode.innerHTML = newCouponCode.innerHTML;
      const couponToggle = oldCouponCode?.querySelector(".coupon-toggle");
      this.clickEvents();
      couponToggle && couponToggle.click();
    }

    let oldSummary = document.querySelector(".drawer__footer");
    let newSummary = doc.querySelector(".drawer__footer");
    console.log({oldSummary,newSummary});
    if(oldSummary && newSummary){
      oldSummary.innerHTML = newSummary.innerHTML;
      this.setCartDiscount();
    }

    let oldDiscount = document.querySelector(".order-discount-wrapper");
    let newDiscount = doc.querySelector(".order-discount-wrapper");
    console.log({oldDiscount,newDiscount});
    if(oldDiscount && newDiscount){
      oldDiscount.innerHTML = newDiscount.innerHTML;
    }
  }
  setCartDiscount=()=>{
    const cartDiscount = document.querySelector('[data-update-coupon]');
    const removeCode = document.querySelector(".coupon-remove");
    cartDiscount && cartDiscount.addEventListener("click", async (e) => {
      const parent = document.querySelector(".coupon-content-inner");
      const errorContainer = document.querySelector(".error-message-coupon-code");
      
      if(parent){
        let input = parent.querySelector(".input");
        if(input){
          const couponCode = input.value.trim();
          if(couponCode.length > 0){
            cartDiscount.classList.add("loading");
            if(cartDiscount.getAttribute("data-applied-code")?.length > 0){
              const errorAlreadyContainer = document.querySelector(".error-message-coupon-code.already");
              errorAlreadyContainer.innerHTML = `We're sorry, it appears you've already redeemed code: "MEM20".`;
              errorAlreadyContainer.classList.remove("hide");
              input.value = "";
              setTimeout(()=>{
                cartDiscount.classList.remove("loading");
              },800)
              return;
            }
            try {
              const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ discount: couponCode })
              });
              const data = await response.json();
              const validCodes = data.discount_codes.filter(code => code.applicable);
              if(validCodes?.length > 0){
                this.updateCart();
              }else {
                errorContainer.innerHTML = `Promo Code "${couponCode}" is not valid.`;
                errorContainer.classList.remove("hide");
                input.value = "";
                this.updateCart(true);
              }
            } catch (error) {
              console.error('Error:', error);
            } finally{
              cartDiscount.classList.remove("loading");
            }
          }
        }
      }
    })  
    removeCode && removeCode.addEventListener("click", async (e) => {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: "" })
      });
      const data = await response.json();
      if(data?.discount_codes?.length == 0){
        this.updateCart();
      }
    })
  }
  clickEvents=()=>{
    const parent = this.parent;
    const couponContent = parent?.querySelector(".coupon-content");
    const couponToggle = parent?.querySelector(".coupon-toggle");
    couponToggle && couponToggle.addEventListener("click",()=>{
      couponContent && couponContent.classList.toggle("collapsed");
      couponToggle && couponToggle.classList.toggle("open");
    })
  }
  init=()=>{
    this.popUpEvents();
    this.clickEvents();
    this.setCartDiscount();
  }  
}

setTimeout(()=>{
  const drawer = document.querySelector(".ctdrawer");
  if(drawer){
    new CartDrawerSnippet(drawer);
  }
},500)

